import { SvgIcon } from '@mui/material'

const Icon = props => (
  <SvgIcon {...props} viewBox="0 0 73 73">
    <g clipPath="url(#aroya-h2o-pressure-icon)">
      <path d="M36.16 71.85c19.524 0 35.35-15.826 35.35-35.35 0-19.523-15.827-35.35-35.35-35.35S.81 16.977.81 36.5s15.827 35.35 35.35 35.35" />
      <path d="M36.5 0C16.373 0 0 16.376 0 36.5S16.373 73 36.5 73 73 56.627 73 36.5 56.627 0 36.5 0m0 71.51c-19.305 0-35.01-15.705-35.01-35.01S17.195 1.49 36.5 1.49 71.51 17.195 71.51 36.5 55.805 71.51 36.5 71.51" />
      <path
        fill="#000"
        d="M67.157 39.202C65.941 54.461 53.725 66.58 38.499 67.77l-.03-4.445c-.008-1.374-.765-2.405-2.01-2.607-1.136-.185-2.712.563-2.76 2.053l-.16 5a31.23 31.23 0 0 1-28.59-28.58l4.52-.102c1.556-.036 2.536-1.085 2.533-2.425-.003-1.341-1.004-2.417-2.53-2.447l-4.514-.09C6.171 18.873 18.393 6.734 33.586 5.563l.063 4.464c.02 1.466.941 2.56 2.273 2.625 1.46.072 2.539-1.064 2.55-2.628l.033-4.46C53.728 6.722 65.947 18.874 67.154 34.13l-4.74.122c-1.446.036-2.295 1.222-2.3 2.413-.007 1.192.851 2.375 2.3 2.414l4.743.125z"
      />
      <path
        fill="#fff"
        d="M36.52 42.992c-1.23 2.08-3.786 2.754-5.747 2.274a5.4 5.4 0 0 1-4.07-4.66c-.241-2.399 1.076-4.47 3.254-5.513l15.687-7.505z"
      />
      <path
        fill="#fff"
        d="M36.52 42.992c-1.23 2.08-3.786 2.754-5.747 2.274a5.4 5.4 0 0 1-4.07-4.66c-.241-2.399 1.076-4.47 3.254-5.513l15.687-7.505z"
      />
    </g>
    <defs>
      <clipPath id="aroya-h2o-pressure-icon">
        <path fill="#fff" d="M0 0h73v73H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
)

export default Icon
